/*
 * @Author: your name
 * @Date: 2022-04-26 15:33:36
 * @LastEditTime: 2024-12-04 17:51:15
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /yach_31_record/packages/auxiliary_ability/src/utils/request.ts
 */
import axios, { AxiosRequestConfig } from 'axios';
import md5 from 'md5';
import userInfo from '@store/authStore';
import history from '@containers/app/ht';
import { logout } from '@genie/sea.uni.jsbridge';
import  currentEnv from '../config'
console.log('加载');

const TIMEOUT = 30 * 1000;
// if you want another config, create one!!
const DEFAULTCONFIG: AxiosRequestConfig = {
    baseURL: currentEnv?.VITE_BASEURL_API  || process.env.VITE_BASEURL_API,
    timeout: TIMEOUT,
};

export function setTokenMock(tokenStr) {
    userInfo.setTokenMock(tokenStr);
}
export async function getToken(cropId, isRefresh = false) {
    try {
        // todo 判断token是否过期
        if (!isRefresh && userInfo?.token) return;
        // if (userInfo?.token) return
        const res = await userInfo.getToken(cropId);
        const token = res?.obj?.data?.token;

        if (token) {
            const authConfig = res?.obj?.data;

            if (authConfig) {
                console.log('auth', authConfig);
            }
        } else {
            history.replace('/404');
        }
    } catch (e) {
        history.replace('/404');
    }
}
function getAxiosInstance() {
    
    const instance = axios.create(DEFAULTCONFIG);
    instance.interceptors.request.use(async (config) => {
        return config;
    });
  
    instance.interceptors.response.use(
        async function (response) {
            return response.data;
        },
        function (error) {
            console.log('===401', error);
            if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
                console.error('请求超时：', error);
                // 在这里执行额外的超时处理逻辑
                return Promise.reject({
                    message: 'The request timed out. Please try again later',
                });
            }
            if (!error.response) {
                return Promise.reject({
                    message: 'Network error, please check the network settings',
                });
            }
            if (error?.response?.status === 401) {
                    setTimeout(() => {
                        logout();  
                    },2000)
                return Promise.reject(error.response.data);
            }

            return Promise.reject(error);
        }
    );

    return instance;
}

const add = function (key: string, value: any, formatOptions: any) {
    value = 'function' === typeof value ? value() : value == null ? '' : value;

    formatOptions[key] = value;
};

/**
 * 构建参数
 * @param key 参数 key
 * @param obj 参数 key 对应的 value
 * @param formatOptions 格式化之后的参数
 */
function buildParams(key: string, obj: any, formatOptions: any) {
    const rbracket = /\[\]$/;
    let value;

    if (Array.isArray(obj) && obj.length) {
        for (let i = 0; obj && i < obj.length; i++) {
            value = obj[i];
            if (rbracket.test(key)) {
                add(key, value, formatOptions);
            } else {
                buildParams(key + '[' + i + ']', value, formatOptions);
            }
        }
    } else if (obj?.constructor === Object) {
        for (let name in obj) {
            buildParams(key + '[' + name + ']', obj[name], formatOptions);
        }
    } else {
        add(key, obj, formatOptions);
    }
}

/**
 * 整合参数，保证前端计算 sign 的参数与给到后端的参数结构一致
 * @param options 参数
 * @returns
 */
const toQueryString = function (options: any) {
    const formatOptions: any = {};

    if (Array.isArray(options)) {
        for (let i = 0; i < options.length; i++) {
            add(options[i]['name'], options[i]['value'], formatOptions);
        }
    } else {
        for (let key in options) {
            if (options.hasOwnProperty(key)) {
                buildParams(key, options[key], formatOptions);
            }
        }
    }

    return formatOptions;
};

/**
 * @author wangzheng_jzb
 * @param options
 */
export function getSign(options = {}) {
    const key = '59266f227cfd7a67797012108df99c9b';
    console.log('options==', options);

    // 系统时间
    const time = new Date();
    // 系统时间与 UTC 时间的差值
    const timezoneOffset = time.getTimezoneOffset();
    // UTC 时间
    const UTCTimestamp = time.getTime() + timezoneOffset * 60 * 1000;
    // 接口需要时间戳 / 秒
    const timestamp = Math.floor(UTCTimestamp / 1000);

    const opt = toQueryString({ ...options, timestamp });

    // 排序
    const keys = Object.keys(opt).sort();

    let signString = '';
    keys.forEach((item) => {
        //@ts-ignore
        const value = typeof opt[item] === 'undefined' ? '' : opt[item];
        signString += `${item}=${value}&`;
    });

    signString += `key=${key}`;

    return { sign: md5(signString), timestamp };
}

const instance = getAxiosInstance();

export function streamRequest(options: any) {
    if ('GET' === options.method) {
        options.params = options.data;
        delete options.data;
    }
    return instance.request({
        method: options.method,
        url: options.url,
        // data: options.data,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'text/event-stream, application/json',
        },
        ...options,
        timeout: 300 * 1000,
    });
}

export default instance;
